import { useEffect } from 'react'

import { Cookies } from '@b-stock/fe-core/bstock-react'

import appConfig from '@config/config'
import CookieManager from '@helpers/CookieManager'
import { gtagFields } from '@helpers/gtag'

export default function GTM() {
  const gtmId = appConfig.googleTagManager.trackingId

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!gtmId) {
      console.error('GTM ID is missing')
      return
    }

    window.dataLayer = window.dataLayer || []

    // Only push default consent once per page session; a remount must not clobber granted consent.
    const win = window as typeof window & { __gtmConsentInitialized?: boolean }
    if (!win.__gtmConsentInitialized) {
      window.dataLayer.push([
        'consent',
        'default',
        {
          ad_storage: 'denied',
          analytics_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          functionality_storage: 'denied',
          personalization_storage: 'denied',
          security_storage: 'denied',
          wait_for_update: 500,
        },
      ])
      win.__gtmConsentInitialized = true
    }

    const uaId = CookieManager.getCookie(Cookies.BSTOCK_UA_ID)
    const isAuthenticated = uaId && uaId !== 'undefined'
    window.dataLayer.push({
      user_status: isAuthenticated
        ? gtagFields.user_status.logged_in
        : gtagFields.user_status.logged_out,
      user_id: isAuthenticated ? uaId : undefined, // GA4 will ignore undefined. This is the safer option.
    })

    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`
    document.head.appendChild(script)
  }, [gtmId])

  return null
}
